import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35c59cd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "no-scroll",
  id: "noscrollcontainer"
}
const _hoisted_2 = { class: "pharagraphs first-pharagraph text-xl md:text-2xl lg:text-4xl w-5/6 md:w-2/6 sm:w-5/12" }
const _hoisted_3 = { class: "break-words text-5xl" }
const _hoisted_4 = { class: "text-md break-words" }
const _hoisted_5 = {
  class: "pharagraphs second-pharagraph text-xl md:text-lg lg:text-4xl w-5/6 md:w-2/6 sm:w-5/12",
  id: "secondp"
}
const _hoisted_6 = { class: "break-words text-5xl" }
const _hoisted_7 = { class: "text-md break-words" }
const _hoisted_8 = { class: "pharagraphs third-pharagraph text-lg md:text-lg lg:text-4xl w-5/6 md:w-2/6 sm:w-5/12" }
const _hoisted_9 = { class: "break-words text-5xl" }
const _hoisted_10 = { class: "text-md break-words" }
const _hoisted_11 = { class: "pharagraphs fourth-pharagraph text-lg md:text-lg lg:text-4xl w-5/6 md:w-2/6 sm:w-5/12" }
const _hoisted_12 = { class: "break-words text-5xl" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "scroll-indicator" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#section05" }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createTextVNode("Scroll")
  ])
], -1))
const _hoisted_14 = {
  id: "container",
  ref: "container",
  class: "webgl overflow-hidden"
}
const _hoisted_15 = {
  id: "divContainer",
  ref: "divContainer",
  class: "divContainer"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "signin-overlay" }, null, -1))
const _hoisted_17 = { class: "nav-dots" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.messagespha1), 1),
        _createElementVNode("small", _hoisted_4, _toDisplayString(_ctx.messagessubpha1), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.messagespha2), 1),
        _createElementVNode("small", _hoisted_7, _toDisplayString(_ctx.messagessubpha2), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.messagespha3), 1),
        _createElementVNode("small", _hoisted_10, _toDisplayString(_ctx.messagessubpha3), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.messagespha4), 1),
        _createElementVNode("button", {
          class: "btn navbar-toggler link-medium flex",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToDiscover && _ctx.goToDiscover(...args)))
        }, _toDisplayString(_ctx.messagessubpha4), 1)
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, null, 512),
      _createElementVNode("div", _hoisted_15, null, 512),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          "data-slide": "1",
          class: _normalizeClass(["nav-dot", {'active-dot': _ctx.activeSection == 0}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToSection(0)))
        }, null, 2),
        _createElementVNode("div", {
          "data-slide": "2",
          class: _normalizeClass(["nav-dot", {'active-dot': _ctx.activeSection == 1}]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToSection(1)))
        }, null, 2),
        _createElementVNode("div", {
          "data-slide": "2",
          class: _normalizeClass(["nav-dot", {'active-dot': _ctx.activeSection == 2}]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToSection(2)))
        }, null, 2),
        _createElementVNode("div", {
          "data-slide": "2",
          class: _normalizeClass(["nav-dot", {'active-dot': _ctx.activeSection == 3}]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToSection(3)))
        }, null, 2)
      ])
    ])
  ], 64))
}